var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Heading'),_c('Introduction'),_c('WhiteSection',{staticClass:"white-section"},[_c('Understanding'),_c('Analytics')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }